import script from "./BallotComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./BallotComponent.vue?vue&type=script&lang=ts&setup=true"

import "./BallotComponent.vue?vue&type=style&index=0&id=c924761c&lang=css"

const __exports__ = script;

export default __exports__